"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var promotedPostSlice_1 = require("../../features/promotedPost/promotedPostSlice");
var SinglePostLinkIcon_1 = __importDefault(require("../Icons/SinglePostLinkIcon"));
var react_router_dom_1 = require("react-router-dom");
var languageSlice_1 = require("../../features/languages/languageSlice");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Tour3DTour = function () {
    var history = react_router_dom_1.useHistory();
    var dispatch = react_redux_1.useDispatch();
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var promotedPosts = react_redux_1.useSelector(promotedPostSlice_1.selectPromotedPosts);
    react_1.useEffect(function () {
        dispatch(promotedPostSlice_1.getPromotedPosts());
    }, []);
    var handleClick = function (slug) {
        history.push("/preview/" + slug);
    };
    if (!promotedPosts.length) {
        return null;
    }
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.tours_container }, promotedPosts.map(function (p, i) {
        var _a;
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.tour, key: i },
            react_1.default.createElement("iframe", { src: (_a = p.tour3d) === null || _a === void 0 ? void 0 : _a.path, frameBorder: "0", allowFullScreen: true, allow: "xr-spatial-tracking", className: "media" }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.address, onClick: function () { return handleClick(p.slug[currentLanguage]); } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null, p.address)),
                react_1.default.createElement(SinglePostLinkIcon_1.default, null))));
    })));
};
exports.default = Tour3DTour;
